import { CreditCardMultipleOutlineIcon } from './CreditCardMultipleOutlineIcon';

/**
 * author: Austin Andrews
 * id D7C8ADB6-B7C9-4653-9EA7-EB98552304BA
 * name credit-card-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-multiple-outline.svg
 * tags
 * - Banking 
 */
export const CreditCardsIcon = CreditCardMultipleOutlineIcon;
export default CreditCardsIcon